import nginxOsGraphs from '@/utils/templates/wsmTemplates/nginx.os.graphs.config.js';
import nginxPlusGraphs from '@/utils/templates/wsmTemplates/nginx.plus.graphs.config.js';

const database = {
  NG: {
    plus: {
      dropdown: {
        show: false
      },
      graphs: {
        template: nginxPlusGraphs.lineCharts
      }
    },
    'open source': {
      dropdown: {
        show: false
      },
      graphs: {
        template: nginxOsGraphs.lineCharts
      }
    }
  }
};
export default database;
